<template>
    <div class="first">
        <div class="container mt-5 py-5">
     <div class="row">
       
       <div class="col-md-9 col-sm-12 mt-2  px-4">
         <div class="text-left ">
           <span class="align-middle">
           <h1 class="py-1 px-4">Manas Paul</h1>
           <div class="mt-2 p1-4 px-4 text">
             <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid doloremque cupiditate, debitis accusamus quas numquam sequi temporibus optio reiciendis illo?</p>
           </div>
           <div class="social mt-5 px-3">
             <Button />
           </div>
           </span>
         </div>
       </div>

       <div class="col-md-3 col-sm-12 text-right image">
         <div class="text-right mb-3">
          <img src="../../public/img/profile.jpg" width="250" height="250" class="rounded-circle" alt="Manas Paul">
        </div>
       </div>
     </div>
   </div>
    </div>
</template>

<script>
import Button from "../components/Button.vue"
export default {
  data() {
    return {
     
    }
  },
  components:{
    Button,
  }
}
</script>

<style scoped>
h1{
  color: #181B1A;
  font-weight: 900;
  font-size: 75px;
}
.container{
  background-color:  rgb(252, 252, 252)!important;
}
a {
    color: #6a6c6e;
    text-decoration: none;
    background-color: transparent;
    font-size: 20px;
}
a:hover{
    color: #04D25A
}

 /* // media */
    @media only screen and (max-width: 760px) {
     .text{
       z-index: 100000;
     }
     .image {
          position: absolute;
          right: 32px;
          top: 182px;
      }
      .image img{
        width: 100px;
        height: 100px;
      }
    }
</style>
